export enum QuestionnaireEvents {
  QuestionnaireToolTipClick = 'tooltip_click',
  QuestionanaireSubmit = 'questionnaire_submit',
}
